module.exports = __webpack_public_path__ + "img/lv0.3ecd3402.png";